@if (isLoading()) {
    <div class="h-full w-full absolute z-99 flex items-center flex-col justify-center backdrop-blur-sm bg-white-gradient">
        <img [src]="logoUrl()" alt="Metropolitan" class="rotate w-18">
        <div class="mt-8 text-4xl tracking-tight leading-tight text-center">You’re being logged in</div>
    </div>
}
<router-outlet></router-outlet>